module.exports = __webpack_public_path__ + "img/minus.723f3bb8.svg";